import { ReactElement } from 'react';
import { MapChartContainer } from './styles';

export function MapChart(): ReactElement {
  return (
    <MapChartContainer>
      <div id="map-chart" />
    </MapChartContainer>
  );
}
